import React from 'react';

const ReduxSagaLogo = () => (
    <svg
        viewBox="0 0 256 157"
        version="1.1"
        className="stack-logo"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
    >
        <g>
            <path
                d="M130.005279,96.2274864 C130.005279,101.498402 126.084419,105.850729 121.000757,106.534269 C114.974281,120.582842 102.699049,134.289318 85.881289,143.998985 C71.7662609,152.1481 56.808266,156.124612 43.3911816,156.124612 C26.3275703,156.124612 11.7548849,149.695476 4.56495141,137.242157 C-7.11185678,117.017502 4.26573913,88.7979212 31.232491,69.7288675 C31.2334731,74.0847959 31.5742609,78.0789852 32.3373504,81.6230465 C30.1613504,83.4576041 28.183734,85.0286322 26.253913,87.0520798 C21.2881023,92.2578496 17.3181381,97.6515274 14.6019847,103.410873 C9.53567263,114.152724 9.19324808,124.306954 13.6372379,132.004305 C18.6436419,140.675568 29.4886138,145.648908 43.3911816,145.648908 C55.4375857,145.648908 68.6674169,141.84099 80.6434373,134.926699 C87.6169821,130.900755 93.8176164,126.065563 99.0738005,120.555016 C104.039611,115.348919 107.934609,109.788939 110.65109,104.029594 C110.887775,103.527742 111.111038,103.027855 111.326118,102.529277 C109.99243,100.780162 109.198568,98.5969596 109.198568,96.2274864 C109.198568,90.4818905 113.856327,85.8244583 119.601923,85.8244583 C125.347519,85.8244583 130.005279,90.4818905 130.005279,96.2274864 Z M83.5778455,-0.000130946292 C106.805099,-0.000130946292 126.055513,24.5434598 129.528863,56.6203908 C125.905907,54.4430813 122.11272,52.6284931 118.140792,51.1949586 C117.667421,48.7158179 117.080454,46.2808716 116.380874,43.896667 C114.355135,36.9931785 111.487738,30.8400123 107.857907,25.6077258 C101.088638,15.8496082 92.4654977,10.4755724 83.5778455,10.4755724 C74.6901934,10.4755724 66.0670527,15.8496082 59.2977841,25.6077258 C55.6679529,30.8400123 52.8005565,36.9931785 50.7748174,43.896667 C48.6308992,51.2037974 47.5437176,58.9915008 47.5437176,67.0437156 C47.5437176,75.0959304 48.6308992,82.8836338 50.7748174,90.1904368 C52.8005565,97.0939253 55.6679529,103.247092 59.2977841,108.479705 C59.6739274,109.021496 60.0559632,109.549209 60.4432368,110.063828 C61.0632675,109.948595 61.7016307,109.885741 62.3547253,109.885741 C68.1006486,109.885741 72.7580808,114.543501 72.7580808,120.288769 C72.7580808,126.034365 68.1006486,130.692125 62.3547253,130.692125 C56.6094568,130.692125 51.9516972,126.034365 51.9516972,120.288769 C51.9516972,119.112544 52.1497535,117.982805 52.5098558,116.92836 C43.0319632,104.654764 37.0680143,86.8549074 37.0680143,67.0437156 C37.0680143,30.0163601 57.8910936,-0.000130946292 83.5778455,-0.000130946292 Z M123.664958,145.646944 C136.422073,145.646944 146.604784,141.459282 152.063935,134.069328 C155.238073,135.74675 158.766093,136.767149 162.490206,137.284714 C155.259024,149.599558 140.630686,156.122648 123.664958,156.122648 C113.173541,156.122648 101.743239,153.692284 90.5080471,148.736622 C94.8800164,146.3223 98.7534077,143.989164 101.622441,141.819712 C109.048405,144.323077 116.562103,145.646944 123.664958,145.646944 Z M140.876767,86.8835192 C135.620583,81.3729719 129.419949,76.5377801 122.446731,72.5118363 C110.470711,65.5972174 97.2418619,61.7892992 85.1977494,61.7892992 L85.1961125,61.7892992 C82.5640921,61.7896266 80.0414118,61.9680409 77.6473862,62.3157033 C77.5864962,62.3245422 77.5275703,62.336 77.4670077,62.3451662 C76.3794987,66.9282864 72.2628747,70.3387826 67.3471509,70.3387826 C61.601555,70.3387826 56.9441228,65.681023 56.9441228,59.9357545 C56.9441228,54.1901586 61.601555,49.532399 67.3471509,49.532399 C70.0449719,49.532399 72.5025064,50.5593453 74.3511407,52.2436419 C74.3652174,52.241023 74.3789668,52.2377494 74.3933708,52.2351304 C77.8398772,51.6226292 81.4575959,51.3139233 85.1941483,51.3135959 C98.6125422,51.3129412 113.567263,55.288798 127.684256,63.4395499 C150.910199,76.8491049 165.489105,97.8800614 166.882046,116.910159 C162.663611,116.435478 159.094343,115.035662 155.812829,113.225657 C155.153187,110.048246 154.032941,106.757238 152.454056,103.408941 C149.737575,97.6492685 145.842578,92.089289 140.876767,86.8835192 Z"
                fill="#999999"
            ></path>
            <path
                d="M247.009097,71.0820338 C251.617751,78.0221872 242.233485,83.4508931 238.030764,76.4724379 C235.4688,72.0994864 231.539102,68.009379 226.388002,64.4358547 C221.155716,60.8060235 215.002222,57.9386271 208.099061,55.9132153 C200.79193,53.7689698 193.004227,52.6817882 184.95234,52.6817882 C176.900125,52.6817882 169.112421,53.7689698 161.805291,55.9132153 C160.547879,56.2821565 159.318294,56.6821974 158.111624,57.1067908 C157.962345,62.7217678 153.366785,67.2286118 147.71547,67.2286118 C141.970202,67.2286118 137.312115,62.5711795 137.312115,56.8255836 C137.312115,51.0799877 141.970202,46.4222281 147.71547,46.4222281 C149.627286,46.4222281 151.416994,46.9404481 152.956268,47.8400491 C162.466242,44.2501565 173.36392,42.2060849 184.95234,42.2060849 C212.982375,42.2060849 236.994652,54.1395478 247.009097,71.0820338 Z M255.755589,96.2274864 C255.755589,101.444059 251.915916,105.762668 246.909512,106.5143 C236.836796,123.369379 212.891302,135.225911 184.952274,135.225911 C163.13433,135.225911 143.750678,127.996039 131.507855,116.801768 C125.585809,110.848622 132.714197,103.931712 138.237512,108.763957 C139.819671,110.239394 141.581553,111.654269 143.516284,112.996141 C148.748571,116.625972 154.901737,119.493369 161.805226,121.519108 C169.112356,123.663026 176.900059,124.750208 184.952274,124.750208 C193.004162,124.750208 200.792192,123.663026 208.098995,121.519108 C215.002484,119.493369 221.155977,116.625972 226.387937,112.996141 C230.927517,109.846883 234.514791,106.295947 237.057113,102.504397 C235.734883,100.759538 234.948878,98.5858292 234.948878,96.2274864 C234.948878,90.4818905 239.606637,85.8244583 245.352561,85.8244583 C251.097829,85.8244583 255.755589,90.4818905 255.755589,96.2274864 Z"
                fill="#89D96D"
            ></path>
        </g>
    </svg>
);

const ReduxLogo = () => (
    <svg
        className="stack-logo"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
    >
        <g fill="#764abc">
            <path d="M65.6 65.4c2.9-.3 5.1-2.8 5-5.8-.1-3-2.6-5.4-5.6-5.4h-.2c-3.1.1-5.5 2.7-5.4 5.8.1 1.5.7 2.8 1.6 3.7-3.4 6.7-8.6 11.6-16.4 15.7-5.3 2.8-10.8 3.8-16.3 3.1-4.5-.6-8-2.6-10.2-5.9-3.2-4.9-3.5-10.2-.8-15.5 1.9-3.8 4.9-6.6 6.8-8-.4-1.3-1-3.5-1.3-5.1-14.5 10.5-13 24.7-8.6 31.4 3.3 5 10 8.1 17.4 8.1 2 0 4-.2 6-.7 12.8-2.5 22.5-10.1 28-21.4z" />
            <path d="M83.2 53c-7.6-8.9-18.8-13.8-31.6-13.8H50c-.9-1.8-2.8-3-4.9-3h-.2c-3.1.1-5.5 2.7-5.4 5.8.1 3 2.6 5.4 5.6 5.4h.2c2.2-.1 4.1-1.5 4.9-3.4H52c7.6 0 14.8 2.2 21.3 6.5 5 3.3 8.6 7.6 10.6 12.8 1.7 4.2 1.6 8.3-.2 11.8-2.8 5.3-7.5 8.2-13.7 8.2-4 0-7.8-1.2-9.8-2.1-1.1 1-3.1 2.6-4.5 3.6 4.3 2 8.7 3.1 12.9 3.1 9.6 0 16.7-5.3 19.4-10.6 2.9-5.8 2.7-15.8-4.8-24.3z" />
            <path d="M32.4 67.1c.1 3 2.6 5.4 5.6 5.4h.2c3.1-.1 5.5-2.7 5.4-5.8-.1-3-2.6-5.4-5.6-5.4h-.2c-.2 0-.5 0-.7.1-4.1-6.8-5.8-14.2-5.2-22.2.4-6 2.4-11.2 5.9-15.5 2.9-3.7 8.5-5.5 12.3-5.6 10.6-.2 15.1 13 15.4 18.3 1.3.3 3.5 1 5 1.5-1.2-16.2-11.2-24.6-20.8-24.6-9 0-17.3 6.5-20.6 16.1-4.6 12.8-1.6 25.1 4 34.8-.5.7-.8 1.8-.7 2.9z" />
        </g>
    </svg>
);

const AntdLogo = () => (
    <svg viewBox="0 0 200 200" className="stack-logo">
        <defs>
            <linearGradient
                x1="62.1023273%"
                y1="0%"
                x2="108.19718%"
                y2="37.8635764%"
                id="linearGradient-1"
            >
                <stop stopColor="#4285EB" offset="0%"></stop>
                <stop stopColor="#2EC7FF" offset="100%"></stop>
            </linearGradient>
            <linearGradient
                x1="69.644116%"
                y1="0%"
                x2="54.0428975%"
                y2="108.456714%"
                id="linearGradient-2"
            >
                <stop stopColor="#29CDFF" offset="0%"></stop>
                <stop stopColor="#148EFF" offset="37.8600687%"></stop>
                <stop stopColor="#0A60FF" offset="100%"></stop>
            </linearGradient>
            <linearGradient
                x1="69.6908165%"
                y1="-12.9743587%"
                x2="16.7228981%"
                y2="117.391248%"
                id="linearGradient-3"
            >
                <stop stopColor="#FA816E" offset="0%"></stop>
                <stop stopColor="#F74A5C" offset="41.472606%"></stop>
                <stop stopColor="#F51D2C" offset="100%"></stop>
            </linearGradient>
            <linearGradient
                x1="68.1279872%"
                y1="-35.6905737%"
                x2="30.4400914%"
                y2="114.942679%"
                id="linearGradient-4"
            >
                <stop stopColor="#FA8E7D" offset="0%"></stop>
                <stop stopColor="#F74A5C" offset="51.2635191%"></stop>
                <stop stopColor="#F51D2C" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="logo13231231231231234"
                transform="translate(-20.000000, -20.000000)"
            >
                <g
                    id="Group-28-Copy-5"
                    transform="translate(20.000000, 20.000000)"
                >
                    <g id="Group-27-Copy-3">
                        <g id="Group-25" fillRule="nonzero">
                            <g id="2">
                                <path
                                    d="M91.5880863,4.17652823 L4.17996544,91.5127728 C-0.519240605,96.2081146 -0.519240605,103.791885 4.17996544,108.487227 L91.5880863,195.823472 C96.2872923,200.518814 103.877304,200.518814 108.57651,195.823472 L145.225487,159.204632 C149.433969,154.999611 149.433969,148.181924 145.225487,143.976903 C141.017005,139.771881 134.193707,139.771881 129.985225,143.976903 L102.20193,171.737352 C101.032305,172.906015 99.2571609,172.906015 98.0875359,171.737352 L28.285908,101.993122 C27.1162831,100.824459 27.1162831,99.050775 28.285908,97.8821118 L98.0875359,28.1378823 C99.2571609,26.9692191 101.032305,26.9692191 102.20193,28.1378823 L129.985225,55.8983314 C134.193707,60.1033528 141.017005,60.1033528 145.225487,55.8983314 C149.433969,51.69331 149.433969,44.8756232 145.225487,40.6706018 L108.58055,4.05574592 C103.862049,-0.537986846 96.2692618,-0.500797906 91.5880863,4.17652823 Z"
                                    id="Shape"
                                    fill="url(#linearGradient-1)"
                                ></path>
                                <path
                                    d="M91.5880863,4.17652823 L4.17996544,91.5127728 C-0.519240605,96.2081146 -0.519240605,103.791885 4.17996544,108.487227 L91.5880863,195.823472 C96.2872923,200.518814 103.877304,200.518814 108.57651,195.823472 L145.225487,159.204632 C149.433969,154.999611 149.433969,148.181924 145.225487,143.976903 C141.017005,139.771881 134.193707,139.771881 129.985225,143.976903 L102.20193,171.737352 C101.032305,172.906015 99.2571609,172.906015 98.0875359,171.737352 L28.285908,101.993122 C27.1162831,100.824459 27.1162831,99.050775 28.285908,97.8821118 L98.0875359,28.1378823 C100.999864,25.6271836 105.751642,20.541824 112.729652,19.3524487 C117.915585,18.4685261 123.585219,20.4140239 129.738554,25.1889424 C125.624663,21.0784292 118.571995,14.0340304 108.58055,4.05574592 C103.862049,-0.537986846 96.2692618,-0.500797906 91.5880863,4.17652823 Z"
                                    id="Shape"
                                    fill="url(#linearGradient-2)"
                                ></path>
                            </g>
                            <path
                                d="M153.685633,135.854579 C157.894115,140.0596 164.717412,140.0596 168.925894,135.854579 L195.959977,108.842726 C200.659183,104.147384 200.659183,96.5636133 195.960527,91.8688194 L168.690777,64.7181159 C164.472332,60.5180858 157.646868,60.5241425 153.435895,64.7316526 C149.227413,68.936674 149.227413,75.7543607 153.435895,79.9593821 L171.854035,98.3623765 C173.02366,99.5310396 173.02366,101.304724 171.854035,102.473387 L153.685633,120.626849 C149.47715,124.83187 149.47715,131.649557 153.685633,135.854579 Z"
                                id="Shape"
                                fill="url(#linearGradient-3)"
                            ></path>
                        </g>
                        <ellipse
                            id="Combined-Shape"
                            fill="url(#linearGradient-4)"
                            cx="100.519339"
                            cy="100.436681"
                            rx="23.6001926"
                            ry="23.580786"
                        ></ellipse>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const MaterializeLogo = () => (
    <svg
        x="0px"
        y="0px"
        viewBox="0 0 114 56.7"
        className="stack-logo"
        enableBackground="new 0 0 114 56.7"
    >
        <g enableBackground="new    ">
            <g enableBackground="new    ">
                <defs>
                    <ellipse
                        id="SVGID_1_"
                        enableBackground="new    "
                        cx="538.6"
                        cy="28.3"
                        rx="0"
                        ry="28.2"
                    />
                </defs>
                <clipPath id="SVGID_2_">
                    <use xlinkHref="#SVGID_1_" overflow="visible" />
                </clipPath>
            </g>
            <g enableBackground="new    ">
                <defs>
                    <ellipse
                        id="SVGID_3_"
                        enableBackground="new    "
                        cx="-374.1"
                        cy="28.3"
                        rx="0"
                        ry="28.2"
                    />
                </defs>
                <clipPath id="SVGID_4_">
                    <use xlinkHref="#SVGID_3_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#SVGID_4_)">
                    <g>
                        <g>
                            <g>
                                <polyline
                                    fill="none"
                                    points="-374.1,-41.8 -374.1,-19.4 -374.1,3 -374.1,-19.4 -374.1,-41.8       "
                                />
                                <polyline
                                    fill="none"
                                    points="-374.1,5.9 -374.1,28.3 -374.1,50.7 -374.1,28.3 -374.1,5.9       "
                                />
                                <polyline
                                    fill="none"
                                    points="-374.1,53.5 -374.1,75.9 -374.1,98.3 -374.1,75.9 -374.1,53.5       "
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g enableBackground="new    ">
                <defs>
                    <path
                        id="SVGID_5_"
                        enableBackground="new    "
                        d="M-374.1,0.1h912.6c0,0,0,12.6,0,28.2c0,15.6,0,28.2,0,28.2h-912.6     c0,0,0-12.6,0-28.2C-374.1,12.7-374.1,0.1-374.1,0.1z"
                    />
                </defs>
                <clipPath id="SVGID_6_">
                    <use xlinkHref="#SVGID_5_" overflow="visible" />
                </clipPath>
            </g>
            <g enableBackground="new    ">
                <defs>
                    <path
                        id="SVGID_7_"
                        enableBackground="new    "
                        d="M-374.1,56.4c0,0,0-12.6,0-28.2c0-15.6,0-28.2,0-28.2h912.6     c0,0,0,12.6,0,28.2c0,15.6,0,28.2,0,28.2C264.8,56.4-100.3,56.4-374.1,56.4z"
                    />
                </defs>
                <clipPath id="SVGID_8_">
                    <use xlinkHref="#SVGID_7_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#SVGID_8_)">
                    <g id="XMLID_1_">
                        <g>
                            <path
                                fill="#EB7077"
                                d="M95,30.3h16.3c-5.7,1.9-7.5,5.7-8.5,16.5c-0.7,7.7-4.2,9.7-4.2,9.7c-2.6,0-5.2-11.1-7.5-22.9       C92,31.6,93.2,30.6,95,30.3z"
                            />
                            <path
                                fill="#EB7077"
                                d="M98.5,56.4H82.2c2.9,0,4.9-5.5,6.1-12.5c0.8-4.7,1.6-8.1,2.7-10.4C93.3,45.3,95.9,56.4,98.5,56.4z"
                            />
                            <path
                                fill="#F6A2AD"
                                d="M91,33.5c-1.2,2.2-2,5.7-2.7,10.4c-1.2,7-3.2,12.5-6.1,12.5c-3.1-0.7-5.6-12.5-8.9-30.5       c-0.1-0.6-0.2-1.1-0.3-1.7c2.5-13,5.1-24.2,7.7-24.2h0.9c3.1,0.7,5.6,12.5,8.9,30.5C90.7,31.6,90.8,32.5,91,33.5z"
                            />
                            <path
                                fill="#EB7077"
                                d="M65.3,0.1h15.4c-2.6,0-5.3,11.2-7.7,24.2C70.7,12.1,68,0.1,65.3,0.1z"
                            />
                            <path
                                fill="#EB7077"
                                d="M73,24.3c-0.2,1.3-0.5,2.6-0.7,4c-3.7,20.2-5.9,27.6-8.5,28.2c-2.9,0-5.7-13.1-8-25.9       c0-0.2-0.1-0.4-0.1-0.6c0.1-0.6,0.2-1.1,0.3-1.7C59.7,8,61.9,0.7,64.4,0.1h0.9C68,0.1,70.7,12.1,73,24.3z"
                            />
                            <path
                                fill="#EB7077"
                                d="M63.8,56.4H47.5c2.8,0,5.6-12.5,8.1-26.5c0,0.2,0.1,0.4,0.1,0.6C58.1,43.4,61,56.4,63.8,56.4z"
                            />
                            <path
                                fill="#F6A2AD"
                                d="M55.7,30c-2.6,14-5.4,26.5-8.1,26.5C44.4,55.7,42,43.9,38.6,26c-0.1-0.6-0.2-1.1-0.3-1.7       c2.5-13,5.1-24.2,7.7-24.2h0.9C50,0.8,52.4,12.4,55.7,30z"
                            />
                            <path
                                fill="#EB7077"
                                d="M30.6,0.1H46c-2.6,0-5.2,11.2-7.7,24.2C36,12.1,33.3,0.1,30.6,0.1z"
                            />
                            <path
                                fill="#EB7077"
                                d="M38.3,24.3c-0.2,1.3-0.5,2.6-0.7,4c-3.7,20.2-5.9,27.6-8.5,28.2c-2.9,0-1.8-0.5-3.6-8.6       c-1.8-8.1-3.2-12.9-5.1-15.4c0.3-1.4,0.5-2.8,0.8-4.2C25,8,27.2,0.7,29.7,0.1h0.9C33.3,0.1,36,12.1,38.3,24.3z"
                            />
                            <path
                                fill="#EB7077"
                                d="M29.1,56.4H12.8c2.6,0,5.2-11.1,7.7-24c1.8,2.5,3.2,7.3,5.1,15.4C27.4,55.9,26.2,56.4,29.1,56.4z"
                            />
                            <path
                                fill="#F6A2AD"
                                d="M20.5,32.4c-2.5,12.9-5.1,24-7.7,24c-0.3-0.4-2.1,0-3.8-10c-1.5-9.2-4.2-15-8.6-16.1h16.3       C18.3,30.4,19.4,31,20.5,32.4z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <path fill="none" d="M194.8,54.9" />
        <g enableBackground="new    ">
            <g enableBackground="new    ">
                <defs>
                    <ellipse
                        id="SVGID_9_"
                        enableBackground="new    "
                        cx="538.6"
                        cy="28.2"
                        rx="0"
                        ry="28.2"
                    />
                </defs>
                <clipPath id="SVGID_10_">
                    <use xlinkHref="#SVGID_9_" overflow="visible" />
                </clipPath>
            </g>
            <g enableBackground="new    ">
                <defs>
                    <ellipse
                        id="SVGID_11_"
                        enableBackground="new    "
                        cx="-374.1"
                        cy="28.2"
                        rx="0"
                        ry="28.2"
                    />
                </defs>
                <clipPath id="SVGID_12_">
                    <use xlinkHref="#SVGID_11_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#SVGID_12_)">
                    <g>
                        <g>
                            <g>
                                <polyline
                                    fill="none"
                                    points="-374.1,-41.9 -374.1,-19.5 -374.1,2.9 -374.1,-19.5 -374.1,-41.9       "
                                />
                                <polyline
                                    fill="none"
                                    points="-374.1,5.8 -374.1,28.2 -374.1,50.6 -374.1,28.2 -374.1,5.8       "
                                />
                                <polyline
                                    fill="none"
                                    points="-374.1,53.4 -374.1,75.8 -374.1,98.2 -374.1,75.8 -374.1,53.4       "
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g enableBackground="new    ">
                <defs>
                    <path
                        id="SVGID_13_"
                        enableBackground="new    "
                        d="M-374.1,0h912.6c0,0,0,12.6,0,28.2s0,28.2,0,28.2h-912.6c0,0,0-12.6,0-28.2     S-374.1,0-374.1,0z"
                    />
                </defs>
                <clipPath id="SVGID_14_">
                    <use xlinkHref="#SVGID_13_" overflow="visible" />
                </clipPath>
            </g>
            <g enableBackground="new    ">
                <defs>
                    <path
                        id="SVGID_15_"
                        enableBackground="new    "
                        d="M-374.1,56.3c0,0,0-12.6,0-28.2s0-28.2,0-28.2h912.6c0,0,0,12.6,0,28.2     s0,28.2,0,28.2C264.8,56.3-100.3,56.3-374.1,56.3z"
                    />
                </defs>
                <clipPath id="SVGID_16_">
                    <use xlinkHref="#SVGID_15_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#SVGID_16_)">
                    <g id="XMLID_2_">
                        <g>
                            <path
                                fill="#EB7077"
                                d="M95,30.2h16.3c-5.7,1.9-7.5,5.7-8.5,16.5c-0.7,7.7-4.2,9.7-4.2,9.7c-2.6,0-5.2-11.1-7.5-22.9       C92,31.5,93.2,30.5,95,30.2z"
                            />
                            <path
                                fill="#EB7077"
                                d="M98.5,56.3H82.2c2.9,0,4.9-5.5,6.1-12.5c0.8-4.7,1.6-8.1,2.7-10.4C93.3,45.2,95.9,56.3,98.5,56.3z"
                            />
                            <path
                                fill="#F6A2AD"
                                d="M91,33.4c-1.2,2.2-2,5.7-2.7,10.4c-1.2,7-3.2,12.5-6.1,12.5c-3.1-0.7-5.6-12.5-8.9-30.5       c-0.1-0.6-0.2-1.1-0.3-1.7C75.5,11.2,78.1,0,80.7,0h0.9c3.1,0.7,5.6,12.5,8.9,30.5C90.7,31.4,90.8,32.4,91,33.4z"
                            />
                            <path
                                fill="#EB7077"
                                d="M65.3,0h15.4c-2.6,0-5.3,11.2-7.7,24.2C70.7,12,68,0,65.3,0z"
                            />
                            <path
                                fill="#EB7077"
                                d="M73,24.2c-0.2,1.3-0.5,2.6-0.7,4c-3.7,20.2-5.9,27.6-8.5,28.2c-2.9,0-5.7-13.1-8-25.9       c0-0.2-0.1-0.4-0.1-0.6c0.1-0.6,0.2-1.1,0.3-1.7C59.7,7.9,61.9,0.6,64.4,0h0.9C68,0,70.7,12,73,24.2z"
                            />
                            <path
                                fill="#EB7077"
                                d="M63.8,56.3H47.5c2.8,0,5.6-12.5,8.1-26.5c0,0.2,0.1,0.4,0.1,0.6C58.1,43.3,61,56.3,63.8,56.3z"
                            />
                            <path
                                fill="#F6A2AD"
                                d="M55.7,29.9c-2.6,14-5.4,26.5-8.1,26.5c-3.1-0.7-5.6-12.5-8.9-30.5c-0.1-0.6-0.2-1.1-0.3-1.7       C40.8,11.2,43.4,0,46,0h0.9C50,0.7,52.4,12.2,55.7,29.9z"
                            />
                            <path
                                fill="#EB7077"
                                d="M30.6,0H46c-2.6,0-5.2,11.2-7.7,24.2C36,12,33.3,0,30.6,0z"
                            />
                            <path
                                fill="#EB7077"
                                d="M38.3,24.2c-0.2,1.3-0.5,2.6-0.7,4c-3.7,20.2-5.9,27.6-8.5,28.2c-2.9,0-1.8-0.5-3.6-8.6       c-1.8-8.1-3.2-12.9-5.1-15.4c0.3-1.4,0.5-2.8,0.8-4.2C25,7.9,27.2,0.6,29.7,0h0.9C33.3,0,36,12,38.3,24.2z"
                            />
                            <path
                                fill="#EB7077"
                                d="M29.1,56.3H12.8c2.6,0,5.2-11.1,7.7-24c1.8,2.5,3.2,7.3,5.1,15.4C27.4,55.8,26.2,56.3,29.1,56.3z"
                            />
                            <path
                                fill="#F6A2AD"
                                d="M20.5,32.3c-2.5,12.9-5.1,24-7.7,24c-0.3-0.4-2.1,0-3.8-10c-1.5-9.2-4.2-15-8.6-16.1h16.3       C18.3,30.2,19.4,30.9,20.5,32.3z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const UikitLogo = () => (
    <svg
        className="stack-logo"
        viewBox="0 0 168 155"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="#33A9D9"
            d="M117.4 33.3L93.3 47.9l27.8 15.8v41.5L83.8 126l-36.7-20.8V73L23 60.7v58.9l59.9 35.2 62.1-35.2V49.2l-27.6-15.9zM106.2 27.5L82.9 14 58.6 29.1l23.6 13z"
        ></path>
    </svg>
);

const ReactLogo = () => (
    <img
        className="stack-logo"
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K"
        alt="React"
    />
);

const SassLogo = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="stack-logo"
        viewBox="0 0 512 384"
    >
        <path
            fill="#CF649A"
            d="M440.6 220.6c-17.9.1-33.4 4.4-46.4 10.8-4.8-9.5-9.6-17.8-10.4-24-.9-7.2-2-11.6-.9-20.2s6.1-20.8 6.1-21.8c-.1-.9-1.1-5.3-11.4-5.4-10.3-.1-19.2 2-20.2 4.7s-3 8.9-4.3 15.3c-1.8 9.4-20.6 42.7-31.3 60.2-3.5-6.8-6.5-12.8-7.1-17.6-.9-7.2-2-11.6-.9-20.2s6.1-20.8 6.1-21.8c-.1-.9-1.1-5.3-11.4-5.4-10.3-.1-19.2 2-20.2 4.7s-2.1 9.1-4.3 15.3c-2.1 6.2-27.1 61.8-33.6 76.3-3.3 7.4-6.2 13.3-8.3 17.3s-.1.3-.3.7c-1.8 3.4-2.8 5.3-2.8 5.3v.1c-1.4 2.5-2.9 4.9-3.6 4.9-.5 0-1.5-6.7.2-15.9 3.7-19.3 12.7-49.4 12.6-50.5 0-.5 1.7-5.8-5.8-8.5-7.3-2.7-9.9 1.8-10.5 1.8-.6 0-1.1 1.6-1.1 1.6s8.1-33.9-15.5-33.9c-14.8 0-35.2 16.1-45.3 30.8-6.4 3.5-20 10.9-34.4 18.8-5.5 3-11.2 6.2-16.6 9.1l-1.1-1.2c-28.6-30.5-81.5-52.1-79.3-93.1.8-14.9 6-54.2 101.6-101.8 78.3-39 141-28.3 151.9-4.5 15.5 34-33.5 97.2-114.9 106.3-31 3.5-47.3-8.5-51.4-13-4.3-4.7-4.9-4.9-6.5-4-2.6 1.4-1 5.6 0 8.1 2.4 6.3 12.4 17.5 29.4 23.1 14.9 4.9 51.3 7.6 95.3-9.4 49.3-19.1 87.8-72.1 76.5-116.4-11.5-45.1-86.3-59.9-157-34.8-42.1 15-87.7 38.4-120.5 69.1-39 36.4-45.2 68.2-42.6 81.4 9.1 47.1 74 77.8 100 100.5-1.3.7-2.5 1.4-3.6 2-13 6.4-62.5 32.3-74.9 59.7-14 31 2.2 53.3 13 56.3 33.4 9.3 67.6-7.4 86.1-34.9 18.4-27.5 16.2-63.2 7.7-79.5l-.3-.6 10.2-6c6.6-3.9 13.1-7.5 18.8-10.6-3.2 8.7-5.5 19-6.7 34-1.4 17.6 5.8 40.4 15.3 49.4 4.2 3.9 9.2 4 12.3 4 11 0 16-9.1 21.5-20 6.8-13.3 12.8-28.7 12.8-28.7s-7.5 41.7 13 41.7c7.5 0 15-9.7 18.4-14.7v.1s.2-.3.6-1c.8-1.2 1.2-1.9 1.2-1.9v-.2c3-5.2 9.7-17.1 19.7-36.8 12.9-25.4 25.3-57.2 25.3-57.2s1.2 7.8 4.9 20.6c2.2 7.6 7 15.9 10.7 24-3 4.2-4.8 6.6-4.8 6.6l.1.1c-2.4 3.2-5.1 6.6-7.9 10-10.2 12.2-22.4 26.1-24 30.1-1.9 4.7-1.5 8.2 2.2 11 2.7 2 7.5 2.4 12.6 2 9.2-.6 15.6-2.9 18.8-4.3 5-1.8 10.7-4.5 16.2-8.5 10-7.4 16.1-17.9 15.5-31.9-.3-7.7-2.8-15.3-5.9-22.5.9-1.3 1.8-2.6 2.7-4 15.8-23.1 28-48.5 28-48.5s1.2 7.8 4.9 20.6c1.9 6.5 5.7 13.6 9.1 20.6-14.8 12.1-24.1 26.1-27.3 35.3-5.9 17-1.3 24.7 7.4 26.5 3.9.8 9.5-1 13.7-2.8 5.2-1.7 11.5-4.6 17.3-8.9 10-7.4 19.6-17.7 19.1-31.6-.3-6.4-2-12.7-4.3-18.7 12.6-5.2 28.9-8.2 49.6-5.7 44.5 5.2 53.3 33 51.6 44.6-1.7 11.6-11 18-14.1 20-3.1 1.9-4.1 2.6-3.8 4 .4 2.1 1.8 2 4.5 1.6 3.7-.6 23.4-9.5 24.2-30.9 1.2-27.5-24.9-57.5-71.2-57.2zm-343.2 115.7c-14.7 16.1-35.4 22.2-44.2 17-9.5-5.5-5.8-29.2 12.3-46.3 11-10.4 25.3-20 34.7-25.9 2.1-1.3 5.3-3.2 9.1-5.5.6-.4 1-.6 1-.6.7-.4 1.5-.9 2.3-1.4 6.7 24.4.3 45.8-15.2 62.7zm107.5-73.1c-5.1 12.5-15.9 44.6-22.4 42.8-5.6-1.5-9-25.8-1.1-49.8 4-12.1 12.5-26.5 17.5-32.1 8.1-9 16.9-12 19.1-8.3 2.6 4.8-9.9 39.6-13.1 47.4zm88.7 42.4c-2.2 1.1-4.2 1.9-5.1 1.3-.7-.4.9-1.9.9-1.9s11.1-11.9 15.5-17.4c2.5-3.2 5.5-6.9 8.7-11.1v1.2c0 14.4-13.8 24-20 27.9zm68.4-15.6c-1.6-1.2-1.4-4.9 4-16.5 2.1-4.6 6.9-12.3 15.2-19.6 1 3 1.6 5.9 1.5 8.6-.1 18-12.9 24.7-20.7 27.5z"
        />
    </svg>
);

const ParcelLogo = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="stack-logo"
        viewBox="0 0 1068.58691 218.40186"
        fill="#E7DACB"
    >
        <path
            d="M134.10156,41.99756c25.2002,0,42.6001,17.40039,42.6001,42.60059v54.60059c0,25.2002-17.3999,42.60059-42.6001,42.60059H66.90088v76.20117H23.7002V41.99756Zm24,46.80078c0-18.6001-10.80029-29.40039-29.40039-29.40039H42.30029V240.6001h6V164.39893h80.40088c18.6001,0,29.40039-10.7998,29.40039-29.40039ZM128.70117,65.39795c15.00049,0,23.40039,8.40039,23.40039,23.40039v46.2002c0,15.00049-8.3999,23.40039-23.40039,23.40039H48.30029v-93.001Zm-5.3999,75.60107c6.6001,0,10.2002-3.6001,10.2002-10.2002V92.99854c0-6.6001-3.6001-10.2002-10.2002-10.2002H66.90088V140.999Z"
            transform="translate(-23.7002 -40.79785)"
        />
        <path
            d="M223.79834,258.00049H179.09766L248.69873,41.99756h50.40039L368.7002,258.00049h-46.501l-14.09961-48.60156H238.19873ZM343.19922,240.6001l-55.5-181.20215H260.09863L203.69824,240.6001h5.7002l15-48.60059H322.7998L337.499,240.6001ZM263.69873,65.39795,226.19824,185.99951H320.999L284.09912,65.39795Zm9.8999,24.00049,22.80029,79.20068h-46.2002Z"
            transform="translate(-23.7002 -40.79785)"
        />
        <path
            d="M509.99512,258.00049l-34.7998-80.10107H440.39453v80.10107h-43.2002V41.99756H507.2959c25.2002,0,42.59961,17.40039,42.59961,42.60059v50.70068c0,20.3999-11.39941,35.7002-29.39941,40.80029l36,81.90137Zm18.90039-17.40039-34.7998-79.80127h7.7998c18.60059,0,29.40039-10.7998,29.40039-29.3999V88.79834c0-18.6001-10.7998-29.40039-29.40039-29.40039H415.79492V240.6001h6V160.79883h66L522.5957,240.6001ZM525.2959,131.39893c0,15-8.40039,23.3999-23.40039,23.3999H421.79492V65.39795h80.10059c15,0,23.40039,8.40039,23.40039,23.40039Zm-28.80078,6.2998c6.60059,0,10.2002-3.6001,10.2002-10.2002v-34.5c0-6.6001-3.59961-10.2002-10.2002-10.2002H440.39453v54.90039Z"
            transform="translate(-23.7002 -40.79785)"
        />
        <path
            d="M697.49316,91.79834c0-6.6001-3.59961-10.2002-10.2002-10.2002h-46.7998c-6.60059,0-10.2002,3.6001-10.2002,10.2002V208.19971c0,6.59961,3.59961,10.19922,10.2002,10.19922H687.293c6.60059,0,10.2002-3.59961,10.2002-10.19922V181.79932h43.20117V216.6001c0,25.19922-17.40039,42.59961-42.60059,42.59961H629.69238c-25.2002,0-42.59961-17.40039-42.59961-42.59961V83.39844c0-25.20068,17.39941-42.60059,42.59961-42.60059h68.40137c25.2002,0,42.60059,17.3999,42.60059,42.60059v34.80029H697.49316Zm-4.7998-27.6001c15,0,23.40039,8.3999,23.40039,23.3999v13.80029h6V87.59814c0-18.6001-10.7998-29.40039-29.40039-29.40039H635.09277c-18.59961,0-29.40039,10.80029-29.40039,29.40039V212.39893c0,18.60059,10.80078,29.40039,29.40039,29.40039h57.60059c18.60059,0,29.40039-10.7998,29.40039-29.40039V199.19971h-6v13.19922c0,15.001-8.40039,23.40039-23.40039,23.40039H635.09277c-15,0-23.40039-8.39941-23.40039-23.40039V87.59814c0-15,8.40039-23.3999,23.40039-23.3999Z"
            transform="translate(-23.7002 -40.79785)"
        />
        <path
            d="M920.38965,41.99756V82.79834H822.28809v44.40039h79.501V167.999h-79.501v49.20068h98.10156v40.80078H779.08789V41.99756ZM901.78906,240.6001v-6H803.68848v-84.001h79.501v-6.00049h-79.501V65.39795h98.10059v-6H797.68848V240.6001Z"
            transform="translate(-23.7002 -40.79785)"
        />
        <path
            d="M1001.68555,41.99756V217.19971h90.60156v40.80078H958.48535V41.99756Zm72.001,198.60254v-6H983.08594V59.39795h-6V240.6001Z"
            transform="translate(-23.7002 -40.79785)"
        />
    </svg>
);

const BootstrapLogo = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="stack-logo"
        viewBox="0 0 1024 860"
        focusable="false"
        role="img"
    >
        <defs>
            <linearGradient
                id="c"
                x1="50%"
                x2="50%"
                y1="0%"
                y2="100%"
            >
                <stop offset="0%" stopColor="#5C24AE"></stop>
                <stop offset="100%" stopColor="#30135A"></stop>
            </linearGradient>
            <path
                id="b"
                d="M355.967 242.807l-322 216.395c-44.275 29.754-44.275 78.443 0 108.197l322 216.395c44.275 29.754 116.725 29.754 161 0l322-216.395c44.275-29.754 44.275-78.443 0-108.197l-322-216.395c-44.275-29.754-116.725-29.754-161 0z"
            ></path>
            <filter
                id="a"
                width="108%"
                height="112%"
                x="-4%"
                y="-4.3%"
                filterUnits="objectBoundingBox"
            >
                <feOffset
                    dy="10"
                    in="SourceAlpha"
                    result="shadowOffsetOuter1"
                ></feOffset>
                <feGaussianBlur
                    in="shadowOffsetOuter1"
                    result="shadowBlurOuter1"
                    stdDeviation="10"
                ></feGaussianBlur>
                <feColorMatrix
                    in="shadowBlurOuter1"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                ></feColorMatrix>
            </filter>
            <linearGradient
                id="f"
                x1="50%"
                x2="50%"
                y1="-17.303%"
                y2="100%"
            >
                <stop offset="0%" stopColor="#7331D4"></stop>
                <stop offset="100%" stopColor="#461B84"></stop>
            </linearGradient>
            <path
                id="e"
                d="M355.967 132.807l-322 216.395c-44.275 29.754-44.275 78.443 0 108.197l322 216.395c44.275 29.754 116.725 29.754 161 0l322-216.395c44.275-29.754 44.275-78.443 0-108.197l-322-216.395c-44.275-29.754-116.725-29.754-161 0z"
            ></path>
            <filter
                id="d"
                width="108%"
                height="112%"
                x="-4%"
                y="-4.3%"
                filterUnits="objectBoundingBox"
            >
                <feOffset
                    dy="10"
                    in="SourceAlpha"
                    result="shadowOffsetOuter1"
                ></feOffset>
                <feGaussianBlur
                    in="shadowOffsetOuter1"
                    result="shadowBlurOuter1"
                    stdDeviation="10"
                ></feGaussianBlur>
                <feColorMatrix
                    in="shadowBlurOuter1"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                ></feColorMatrix>
            </filter>
            <linearGradient
                id="i"
                x1="50%"
                x2="50%"
                y1="0%"
                y2="100%"
            >
                <stop offset="0%" stopColor="#905BDD"></stop>
                <stop offset="100%" stopColor="#5521A0"></stop>
            </linearGradient>
            <path
                id="h"
                d="M355.967 22.807l-322 216.395c-44.275 29.754-44.275 78.443 0 108.197l322 216.395c44.275 29.754 116.725 29.754 161 0l322-216.395c44.275-29.754 44.275-78.443 0-108.197l-322-216.395c-44.275-29.754-116.725-29.754-161 0z"
            ></path>
            <filter
                id="g"
                width="108%"
                height="112%"
                x="-4%"
                y="-4.3%"
                filterUnits="objectBoundingBox"
            >
                <feOffset
                    dy="10"
                    in="SourceAlpha"
                    result="shadowOffsetOuter1"
                ></feOffset>
                <feGaussianBlur
                    in="shadowOffsetOuter1"
                    result="shadowBlurOuter1"
                    stdDeviation="10"
                ></feGaussianBlur>
                <feColorMatrix
                    in="shadowBlurOuter1"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                ></feColorMatrix>
            </filter>
        </defs>
        <g fill="none">
            <g transform="translate(75 23)">
                <use
                    fill="#000"
                    filter="url(#a)"
                    xlinkHref="#b"
                ></use>
                <use fill="url(#c)" xlinkHref="#b"></use>
            </g>
            <g transform="translate(75 23)">
                <use
                    fill="#000"
                    filter="url(#d)"
                    xlinkHref="#e"
                ></use>
                <use fill="url(#f)" xlinkHref="#e"></use>
            </g>
            <g transform="translate(75 23)">
                <use
                    fill="#000"
                    filter="url(#g)"
                    xlinkHref="#h"
                ></use>
                <use fill="url(#i)" xlinkHref="#h"></use>
            </g>
            <path
                fill="#FFF"
                d="M558.273 447.667L308.036 279.5l97.982-65.847c42.83-28.784 96.789-31.483 134.245-6.311 26.044 17.502 31.214 46.615 11.444 65.724l1.389.934c38.324-19.932 84.107-18.527 117.396 3.845 44.046 29.6 38.671 68.419-14.561 104.193l-97.658 65.629zM447.112 331.01l49.942-33.562c36.935-24.822 42.31-48.249 15.224-66.451-24.798-16.665-55.49-14.453-85.851 5.95l-59.641 40.081 80.326 53.982zm176.532 35.663c37.63-25.289 42.136-48.832 13.203-68.276-28.932-19.444-64.163-15.614-104.042 11.186l-58.789 39.508 87.92 59.084 61.708-41.502z"
            ></path>
        </g>
    </svg>
);

const SvelteLogo = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        className="stack-logo"
        viewBox="0 0 98.1 118"
    >
        <path
            fill="#FF3E00"
            d="M91.8,15.6C80.9-0.1,59.2-4.7,43.6,5.2L16.1,22.8C8.6,27.5,3.4,35.2,1.9,43.9c-1.3,7.3-0.2,14.8,3.3,21.3  c-2.4,3.6-4,7.6-4.7,11.8c-1.6,8.9,0.5,18.1,5.7,25.4c11,15.7,32.6,20.3,48.2,10.4l27.5-17.5c7.5-4.7,12.7-12.4,14.2-21.1  c1.3-7.3,0.2-14.8-3.3-21.3c2.4-3.6,4-7.6,4.7-11.8C99.2,32.1,97.1,22.9,91.8,15.6"
        />
        <path
            fill="#FFFFFF"
            d="M40.9,103.9c-8.9,2.3-18.2-1.2-23.4-8.7c-3.2-4.4-4.4-9.9-3.5-15.3c0.2-0.9,0.4-1.7,0.6-2.6l0.5-1.6l1.4,1  c3.3,2.4,6.9,4.2,10.8,5.4l1,0.3l-0.1,1c-0.1,1.4,0.3,2.9,1.1,4.1c1.6,2.3,4.4,3.4,7.1,2.7c0.6-0.2,1.2-0.4,1.7-0.7L65.5,72  c1.4-0.9,2.3-2.2,2.6-3.8c0.3-1.6-0.1-3.3-1-4.6c-1.6-2.3-4.4-3.3-7.1-2.6c-0.6,0.2-1.2,0.4-1.7,0.7l-10.5,6.7  c-1.7,1.1-3.6,1.9-5.6,2.4c-8.9,2.3-18.2-1.2-23.4-8.7c-3.1-4.4-4.4-9.9-3.4-15.3c0.9-5.2,4.1-9.9,8.6-12.7l27.5-17.5  c1.7-1.1,3.6-1.9,5.6-2.5c8.9-2.3,18.2,1.2,23.4,8.7c3.2,4.4,4.4,9.9,3.5,15.3c-0.2,0.9-0.4,1.7-0.7,2.6l-0.5,1.6l-1.4-1  c-3.3-2.4-6.9-4.2-10.8-5.4l-1-0.3l0.1-1c0.1-1.4-0.3-2.9-1.1-4.1c-1.6-2.3-4.4-3.3-7.1-2.6c-0.6,0.2-1.2,0.4-1.7,0.7L32.4,46.1  c-1.4,0.9-2.3,2.2-2.6,3.8s0.1,3.3,1,4.6c1.6,2.3,4.4,3.3,7.1,2.6c0.6-0.2,1.2-0.4,1.7-0.7l10.5-6.7c1.7-1.1,3.6-1.9,5.6-2.5  c8.9-2.3,18.2,1.2,23.4,8.7c3.2,4.4,4.4,9.9,3.5,15.3c-0.9,5.2-4.1,9.9-8.6,12.7l-27.5,17.5C44.8,102.5,42.9,103.3,40.9,103.9"
        />
    </svg>
);

const MobxLogo = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 256"
        preserveAspectRatio="xMidYMid"
        className="stack-logo"
    >
        <path
            d="M256 236.394V19.607c0-8.894-5.923-16.4-14.037-18.8l-9.215 5.514-102.265 109.037-3.206 10.021-1.873 9.62 31.89 119.18 4.933 1.82h74.167c10.828 0 19.606-8.777 19.606-19.605"
            fill="#EA6618"
        />
        <path
            d="M0 19.606v216.787c0 6.705 3.367 12.62 8.5 16.155l6.287-3.01 108.246-115.894 4.244-8.265.159-7.99L97.976 5.306 93.513 0H19.606C8.778 0 0 8.778 0 19.606"
            fill="#d65813"
        />
        <path
            d="M127.277 125.38L241.963.806a19.595 19.595 0 0 0-5.57-.807H93.515l33.763 125.38z"
            fill="#e05e11"
        />
        <path
            d="M19.606 256h142.622l-34.951-130.621L8.499 252.549A19.511 19.511 0 0 0 19.606 256"
            fill="#de5c16"
        />
        <path
            d="M94.918 97.03h14.225c5.668 21.386 12.119 40.152 19.316 57.085 8.152-19.05 14.127-37.83 19.185-57.086h13.442c-6.02 23.926-15.868 48.04-27.132 72.93h-11.89c-10.82-23.586-20.03-47.837-27.146-72.93zm-46.92-37.055h31.63v135.637h-31.77v-10.456H67.33V70.152H47.998V59.975zm160.169 10.177h-19.332v115.004h19.47v10.456h-31.769V59.975h31.63v10.177z"
            fill="#FFF"
        />
    </svg>
);

export {
    ReduxSagaLogo,
    BootstrapLogo,
    SassLogo,
    ParcelLogo,
    SvelteLogo,
    UikitLogo,
    MaterializeLogo,
    AntdLogo,
    MobxLogo,
    ReduxLogo,
    ReactLogo
};
